/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebhookDelivery } from './WebhookDelivery';
import {
    WebhookDeliveryFromJSON,
    WebhookDeliveryFromJSONTyped,
    WebhookDeliveryToJSON,
    WebhookDeliveryToJSONTyped,
} from './WebhookDelivery';

/**
 * 
 * @export
 * @interface ListWebhookDeliveriesResponse
 */
export interface ListWebhookDeliveriesResponse {
    /**
     * One page, in the requested order.
     * @type {Array<WebhookDelivery>}
     * @memberof ListWebhookDeliveriesResponse
     */
    deliveries: Array<WebhookDelivery>;
    /**
     * Every delivery matching the filters within the retention window, not just this page.
     * @type {number}
     * @memberof ListWebhookDeliveriesResponse
     */
    totalCount: number;
    /**
     * Zero-based.
     * @type {number}
     * @memberof ListWebhookDeliveriesResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ListWebhookDeliveriesResponse
     */
    pageSize: number;
    /**
     * How many days back the list reaches, and how old a failed delivery may be and still be re-sent.
     * @type {number}
     * @memberof ListWebhookDeliveriesResponse
     */
    retentionDays: number;
    /**
     * How many times one delivery may be re-sent from the Dashboard before contacting FreightSimple.
     * @type {number}
     * @memberof ListWebhookDeliveriesResponse
     */
    maxCustomerRetries: number;
}

/**
 * Check if a given object implements the ListWebhookDeliveriesResponse interface.
 */
export function instanceOfListWebhookDeliveriesResponse(value: object): value is ListWebhookDeliveriesResponse {
    if (!('deliveries' in value) || value['deliveries'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('retentionDays' in value) || value['retentionDays'] === undefined) return false;
    if (!('maxCustomerRetries' in value) || value['maxCustomerRetries'] === undefined) return false;
    return true;
}

export function ListWebhookDeliveriesResponseFromJSON(json: any): ListWebhookDeliveriesResponse {
    return ListWebhookDeliveriesResponseFromJSONTyped(json, false);
}

export function ListWebhookDeliveriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWebhookDeliveriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'deliveries': ((json['deliveries'] as Array<any>).map(WebhookDeliveryFromJSON)),
        'totalCount': json['totalCount'],
        'page': json['page'],
        'pageSize': json['pageSize'],
        'retentionDays': json['retentionDays'],
        'maxCustomerRetries': json['maxCustomerRetries'],
    };
}

  export function ListWebhookDeliveriesResponseToJSON(json: any): ListWebhookDeliveriesResponse {
      return ListWebhookDeliveriesResponseToJSONTyped(json, false);
  }

  export function ListWebhookDeliveriesResponseToJSONTyped(value?: ListWebhookDeliveriesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deliveries': ((value['deliveries'] as Array<any>).map(WebhookDeliveryToJSON)),
        'totalCount': value['totalCount'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'retentionDays': value['retentionDays'],
        'maxCustomerRetries': value['maxCustomerRetries'],
    };
}

